import { GET, POST, PUT, DELETE } from '../utils/request';
import { CATALOG_SERVICE_API_PREFIX } from 'src/consts/third_party';

export function queryOpenItemList({ restaurantId }) {
  return GET(`${CATALOG_SERVICE_API_PREFIX}/api/v1/restaurants/${restaurantId}/meal_open_items`);
}

export function createOpenItem({ restaurantId, ...data }) {
  return POST(`${CATALOG_SERVICE_API_PREFIX}/api/v1/restaurants/${restaurantId}/meal_open_items`, data);
}

export function updateOpenItem({ id, restaurantId, ...data }) {
  return PUT(`${CATALOG_SERVICE_API_PREFIX}/api/v1/restaurants/${restaurantId}/meal_open_items/${id}`, data);
}

export function deleteOpenItem({ id, restaurantId }) {
  return DELETE(`${CATALOG_SERVICE_API_PREFIX}/api/v1/restaurants/${restaurantId}/meal_open_items/${id}`);
}
